export type DayOption = {
	label: string;
	value: string;
};
export const weekDays: DayOption[] = [
	{ label: 'S', value: 'sunday' },
	{ label: 'M', value: 'monday' },
	{ label: 'T', value: 'tuesday' },
	{ label: 'W', value: 'wednesday' },
	{ label: 'T', value: 'thursday' },
	{ label: 'F', value: 'friday' },
	{ label: 'S', value: 'saturday' },
];
